import { Inbox } from "@assets";

export const NoRemoteAssessments = (): JSX.Element => {
    return (
        <div className="w-80">
            <div className="box my-6">
                <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center has-text-center">
                    <div className="title my-5">You have no remote assessments</div>
                    <Inbox />
                </div>
            </div>
        </div>
    );
};
